export function toSentenceCase(value?: string) {
	if (!value) { return value; }
	return value.substr(0, 1).toUpperCase() + value.slice(1).toLowerCase();
}
